import { TAny } from 'types';

const useCamera = (
  videoRef: TAny,
  canvasRef: TAny,
  downloadRef: TAny,
  outputSourceRef: TAny
) => {
  const handleDataAvailable = (event: TAny) => {
    if (event.data.size > 0) {
      const recordedChunks = [event.data];

      const _type = 'video/webm';
      const extension = 'webm';

      // Download.
      const blob = new Blob(recordedChunks, { type: _type });
      const url = URL.createObjectURL(blob);
      downloadRef.current.href = url;
      downloadRef.current.download = `wideo-background-remover.${extension}`;
      outputSourceRef.current.src = url;
    }
  };

  const _options = { mimeType: 'video/webm' };

  const ctx = canvasRef.current.getContext('2d');
  const stream = canvasRef.current.captureStream();
  const options = _options;
  const mediaRecorder = new MediaRecorder(stream, options);
  mediaRecorder.ondataavailable = handleDataAvailable;

  const drawToCanvas = (canvas: TAny) => {
    ctx.drawImage(
      canvas,
      0,
      0,
      videoRef.current.videoWidth,
      videoRef.current.videoHeight
    );
  };

  const drawFromVideo = (ctx: TAny) => {
    ctx.drawImage(
      videoRef,
      0,
      0,
      videoRef.current.videoWidth,
      videoRef.current.videoHeight
    );
  };

  const clearCtx = () => {
    ctx.clearRect(
      0,
      0,
      videoRef.current.videoWidth,
      videoRef.current.videoHeight
    );
  };

  const start = () => {
    mediaRecorder.start();
  };

  const stop = () => {
    mediaRecorder.stop();
  };

  return {
    drawToCanvas,
    drawFromVideo,
    clearCtx,
    start,
    stop,
  };
};

export default useCamera;
